export const environment = {
  production: false,
  apiBaseUrl: 'https://app-comforce-api-centralus-stag-hka6bpf5fcdqewc8.centralus-01.azurewebsites.net/api',
  apiKey: '7f392b88e1a24d54b3e7a9c2f1d80d31',
  comforceURL: 'https://app-comforce-core-container-centralus-stag-cdggfbg7fpcagnf7.centralus-01.azurewebsites.net',
  comtrakURL: "https://comtrak.stage.dmclinical.com",
  externalAuthCookieName: 'user'
};
